import PropTypes from 'prop-types';
import React from 'react';

class FormCheckBox extends React.Component {
  static get propTypes() {
    return {
      children: PropTypes.any,
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      onChange: PropTypes.func,
    };
  }

  render() {
    return (
      <div className="c-form_cb -center">
        <input
          id={this.props.id}
          type="checkbox"
          onChange={this.props.onChange}
        />
        <label htmlFor={this.props.id}>
          <span className="c-form_cb_box"></span>
          {this.props.children}
        </label>
      </div>
    );
  }
}

export default FormCheckBox;
